import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import adDetailsModule from '@store/modules/ad-details';
import adFormModule from '@store/modules/ad-form';
import adsModule from '@store/modules/ads';
import areaModule from '@store/modules/area';
import landLocatorModule from '@store/modules/land-locator';
import userModule from '@store/modules/user';

import { pageState } from '@helpers/page-state';
import { getUrlSegment } from '@helpers/url-handler';

Vue.use(Vuex, {
    strict: true,
});

const vuexLocal = new VuexPersistence({
    key: 'krispyhouse',
    storage: window.localStorage,
    reducer: (state) => ({ app: state.app }),
});

const state = {
    pageState,
    accountTypes: [],
    accountTypeDefault: '',
    individualTypes: [],
    individualTypeDefault: '',
    depositSchemes: [],
    acreditedLandlordBodies: [],
    incomes: [],
    agentAffiliateGroups: [],
    alertTypes: [],
    conversationsState: [],
    inAppNotifications: [],
    isLoadedAppState: false,
    app: window.localStorage.app || {
        showMap: false,
    },
};

const getters = {

};

const actions = {
    setAppState({ commit }) {
        const params = {};

        if (getUrlSegment(1) === 'chat') {
            params.chat = true;
        } else if (getUrlSegment(2) === 'chat' && getUrlSegment(3)) {
            params.chat = true;
            params.chat_acting_as = getUrlSegment(3);
        }

        axios.get('/api/app/state', { params })
            .then(async ({ data }) => {
                commit('user/setUser', data.user, { root: true });
                if (data.user && data.user.agents) {
                    await commit('user/setUserAgents', data.user.agents, { root: true });
                    commit('user/setUserAgentsTotal', { root: true });
                }
                if (data.user && data.user.in_app_notifications) {
                    commit('setInAppNotifications', data.user.in_app_notifications.data);
                }
                if (data.accountTypes) {
                    commit('setAccountTypes', data.accountTypes);
                }
                if (data.accountTypeDefault) {
                    commit('setAccountTypeDefault', data.accountTypeDefault);
                }
                if (data.individualTypes) {
                    commit('setIndividualTypes', data.individualTypes);
                }
                if (data.individualTypeDefault) {
                    commit('setIndividualTypeDefault', data.individualTypeDefault);
                }
                if (data.depositSchemes) {
                    commit('setDepositSchemes', data.depositSchemes);
                }
                if (data.acreditedLandlordBodies) {
                    commit('setAcreditedLandlordBodies', data.acreditedLandlordBodies);
                }
                if (data.incomes) {
                    commit('setIncomes', data.incomes);
                }
                if (data.agentAffiliateGroups) {
                    commit('setAgentAffiliateGroups', data.agentAffiliateGroups);
                }
                if (data.alertTypes) {
                    commit('setAlertTypes', data.alertTypes);
                }
                if (data.conversationsState) {
                    commit('setConversationsState', data.conversationsState);
                }
            })
            .finally(() => commit('setIsLoadedAppState', true));
    },
};

const mutations = {
    setAccountTypes(state, payload) {
        state.accountTypes = payload;
    },
    setAccountTypeDefault(state, payload) {
        state.accountTypeDefault = payload;
    },
    setIndividualTypes(state, payload) {
        state.individualTypes = payload;
    },
    setIndividualTypeDefault(state, payload) {
        state.individualTypeDefault = payload;
    },
    setDepositSchemes(state, payload) {
        state.depositSchemes = payload;
    },
    setAcreditedLandlordBodies(state, payload) {
        state.acreditedLandlordBodies = payload;
    },
    setIncomes(state, payload) {
        state.incomes = payload;
    },
    setAgentAffiliateGroups(state, payload) {
        state.agentAffiliateGroups = payload;
    },
    setAlertTypes(state, payload) {
        state.alertTypes = payload;
    },
    setIsLoadedAppState(state, payload) {
        state.isLoadedAppState = payload;
    },
    toggleMapView(state) {
        state.app.showMap = !state.app.showMap;
    },
    setConversationsState(state, payload) {
        state.conversationsState = payload;
    },
    setInAppNotifications(state, payload) {
        state.inAppNotifications = payload;
    },
};

const store = new Vuex.Store({
    strict: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        user: userModule,
        ads: adsModule,
        area: areaModule,
        adForm: adFormModule,
        adDetails: adDetailsModule,
        landLocator: landLocatorModule,
    },
    plugins: [vuexLocal.plugin],
});

store.dispatch('setAppState');

export default store;
